'use strict'

module.exports = {
  createClient: require('./lib/client'),
  AUDIT_LOG_EVENTS: require('./lib/events')
}
